// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { SubmissionError } from 'redux-form'
import getStateCodes from 'helpers/getStateCodes'

import {
  setPathDatabaseHighlightedIds,
  setPathDatabaseData,
} from 'redux/modules/pathDatabase'

import {
  assembleQuery,
  fetchWrapper,
} from 'helpers/api'

const handlePathDatabaseSearch = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      try {
        // blurs the active DOM element
        document.activeElement.blur()
        var stateCodes
        const {
          selectInput,
          textInput,
        } = formValues

        if (textInput.length < 2) {
          throw new Error('Must search by at least two characters.')
        }

        if (selectInput === 'state' && textInput.length > 2) {
          stateCodes = getStateCodes(textInput)[0]
        }

        const query = assembleQuery([{
          field: selectInput,
          value: stateCodes || textInput,
        }])

        const data = await fetchWrapper(`/path${query}`)

        // clears highlighted path ids
        dispatch(setPathDatabaseHighlightedIds())

        const cleanedData = data.map(d => {
          // the JSON has this value as a String when it should be a Float/Double.
          d.band_id = parseFloat(d.band_id)
          return d
        })

        // sets new data
        dispatch(setPathDatabaseData(cleanedData))

        return cleanedData
      } catch (err) {
        console.warn(err)
        throw new SubmissionError({
          _error: err.message || 'Uncaught Error!',
        })
      }
    })
  )
)

export default handlePathDatabaseSearch
